import { render, staticRenderFns } from "./CategoryManagementListItem.vue?vue&type=template&id=b1973cce"
import script from "./CategoryManagementListItem.vue?vue&type=script&lang=js"
export * from "./CategoryManagementListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports